import React from 'react';
import KickImage from 'Reuseables/KickImage';
import { Row, Col } from 'antd';
import { useHistory } from 'react-router';

import Styles from './ButtonUnAuth.module.scss';
import Text from 'Pages/Home/Components/Atoms/Text';

const ButtonUnAuth: React.FC = () => {
  const history = useHistory();
  const onLoginClicked = () => history.push('/login');
  const onRegisterClicked = () => history.push('/register');
  return (
    <Row align='middle' gutter={12}>
      <Col>
        <Text onClick={onLoginClicked} className={Styles['unauth-button-text']}>Login</Text>
      </Col>
      <Col>
        <Text onClick={onRegisterClicked} className={Styles['unauth-button-text']}>Register</Text>
      </Col>
    </Row>
  )
}

export default ButtonUnAuth;